/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useRef, useState } from "react";
// import "./EconomicsYear.css";
import { Helmet } from "react-helmet-async";
import FormBtn from "../../component/buttons/Form/FormBtn";
import FooterDevOfficer from "../../component/footer/VillageDevelopmentOfficer/FooterDevOfficer";
import Village_Tal_Dist_Mahe from "../../component/header-navigate/Village_Tal_Dist_Mahe/Village_Tal_Dist_Mahe";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { FaEdit } from "react-icons/fa";
import Loader from "../../component/Loader/Loader";
import {
  API_AUTH_USERNAME,
  API_AUTH_PASSWORD,
  API_BASE_URL,
} from "../../Constant/Global";
import Village_Tal_Dist from "../../component/header-navigate/Village_Tal_Dist/Village_Tal_Dist";
import EconomicsYear_Expanse1 from "./EconomicsYear_Expanse1";
import EconomicsYear_Expanse2 from "./EconomicsYear_Expanse2";
import { Button } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import { MdOutlineArrowDownward } from "react-icons/md";

const EconomicsYear_E = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [villageDataInfo, setVillageDataInfo] = useState("");
  const [yearInfo, setYearInfo] = useState("");
  const [economicData, setEconomicData] = useState("");
  const [expenseAData, setExpenseAData] = useState([]);
  const [month, setMonth] = useState("");
  const [validated, setValidated] = useState(false);

  var userDataInfo = sessionStorage.getItem("info");
  var userInfo = JSON.parse(userDataInfo);
  var userDetails = userInfo.user_details;
  //  १५% मागासवर्गीय खर्चाची तरतूद  input filed calculation

  const [backLog, setBackLog] = useState("");
  const [currentProvision, setCurrentProvision] = useState("");
  const [totalProvision, setTotalProvision] = useState("");

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [errors, setErrors] = useState({
    backLog: "",
    currentProvision: "",
  });

  const validation = () => {
    let valid = true;
    const newErrors = {
      backLog: "",
      currentProvision: "",
    };

    // backLog validation
    if (backLog.trim() === "") {
      // toast.error((newErrors.backLog = "कृपया मागील अनुशेष टाका *"));
      newErrors.backLog = "कृपया मागील अनुशेष टाका *";
      valid = false;
    }

    // currentProvision validation
    if (currentProvision.trim() === "") {
      // toast.error((newErrors.currentProvision = "कृपया चालू तरतूद टाका *"));
      newErrors.currentProvision = "कृपया चालू तरतूद टाका *";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const CalculateTotalProvision = () => {
    const num1 = parseFloat(backLog) || 0;
    const num2 = parseFloat(currentProvision) || 0;

    if (isNaN(num1) || isNaN(num2)) {
      setTotalProvision("");
    } else {
      const sum = num1 + num2;
      setTotalProvision(Math.round(sum));
    }
  };

  useEffect(() => {
    CalculateTotalProvision();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backLog, currentProvision]);

  // खर्च तरतूद (१५% मागासवर्गीय खर्चाची तरतूद) Get Information api

  const handleEconomicsYearDetails = async () => {
    try {
      const finalData = {
        gram_sevek_id: userDetails.id,
        village_id: userDetails.village_id,
        taluka_id: userDetails.taluka_id,
        district_id: userDetails.district_id,
        year_id: userDetails.current_year_id,
        type: "backward_class",
      };
      // console.log("finalData", finalData);
      const response = await axios.post(
        API_BASE_URL + "api/economic_e",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      setIsLoading(false);
      console.log("Economics_E_Details response", response.data.data);
      setVillageDataInfo(response.data.data.other_data);
      setYearInfo(response.data.data.year_info);
      setExpenseAData(response.data.data.economic_e_data);

      if (
        response.data.data.economic_e_data === null ||
        response.data.data.economic_e_data.length === 0
      ) {
        setEconomicData("");
      } else {
        setEconomicData(response.data.data.economic_e_data.is_draft);
      }
      setMonth(response.data.data.month);

      // updated date show in inputs

      setBackLog(response.data.data.economic_e_data.backlog);
      setCurrentProvision(response.data.data.economic_e_data.current_provision);
      setTotalProvision(response.data.data.economic_e_data.total_provision);
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.data);
        console.log(error.response.status);
      }
    }
  };

  useEffect(() => {
    handleEconomicsYearDetails();
  }, []);

  const handleDataRefresh = async () => {
    await handleEconomicsYearDetails();
  };

  const handleDataReset = async () => {
    if (expenseAData !== null) {
      await handleEconomicsYearDetails();
      setValidated(false);
    } else {
      setBackLog("");
      setCurrentProvision("");
      setTotalProvision("");
      setValidated(false);
    }
  };

  // Refs for input elements
  const backLogRef = useRef(null);
  const currentProvisionRef = useRef(null);

  useEffect(() => {
    // Set focus on the first input with an error
    if (validated) {
      if (!isNumeric(backLog)) {
        backLogRef.current.focus();
      } else if (!isNumeric(currentProvision)) {
        currentProvisionRef.current.focus();
      }
      // ... (add similar conditions for other inputs)
    }
  }, [validated]);

  // Validation functions
  const isNumeric = (value) => {
    return /^-?\d*\.?\d+$/.test(value);
  };

  // before submission check validation
  const handleFormSubmission = async (e) => {
    e.preventDefault();
  
    const isValid = () =>{
      if (!isNumeric(backLog) || !isNumeric(currentProvision)) {
        setValidated(true);
        return true;
      }
      return false;
    }
    if (isValid()) {
      if(validated){
        await handleExpenseProvisionDetails(e);
      }
    }else{
      handleShow();
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Optional smooth scrolling
    });
  };

  // खर्च तरतूद (१५% मागासवर्गीय खर्चाची तरतूद)  Update Information api

  const handleExpenseProvisionDetails = async (e) => {
    e.preventDefault();
    if (!isNumeric(backLog) || !isNumeric(currentProvision)) {
      setValidated(true);
      scrollToTop();
      return;
    }

    handleClose();
    try {
      const finalData = {
        year_id: userDetails.current_year_id,
        gram_sevek_id: userDetails.id,
        village_id: userDetails.village_id,
        taluka_id: userDetails.taluka_id,
        district_id: userDetails.district_id,
        type: "backward_class",
        economic_e_data: [
          {
            backlog: backLog,
            current_provision: currentProvision,
            total_provision: totalProvision,
          },
        ],
      };
      console.log("updateEconomic_E finalData", finalData);

      const response = await axios.post(
        API_BASE_URL + "api/update_economic_e",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      setIsLoading(false);
      console.log("updateEconomic_E response", response.data.data);
      if (response.data.status === true) {
        toast.success(response.data.message);
        setValidated(false);
        setTimeout(() => {
          handleDataRefresh();
        }, 2000);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error.response.data.error);
    }
  };

  // खर्च तरतूद (१५% मागासवर्गीय खर्चाची तरतूद)  Draft Information api

  const handleDraftExpenseProvision = async (e) => {
    e.preventDefault();

    const invalidFormats =
      (!isNumeric(backLog) && backLog !== "") ||
      (!isNumeric(currentProvision) && currentProvision !== "");
    if (invalidFormats) {
      setValidated(true);
      return;
    }

    try {
      const finalData = {
        year_id: userDetails.current_year_id,
        gram_sevek_id: userDetails.id,
        village_id: userDetails.village_id,
        taluka_id: userDetails.taluka_id,
        district_id: userDetails.district_id,
        type: "backward_class",
        economic_e_data: [
          {
            backlog: backLog,
            current_provision: currentProvision,
            total_provision: totalProvision,
          },
        ],
      };
      console.log("DraftExpenseProvision_A finalData", finalData);
      const response = await axios.post(
        API_BASE_URL + "api/draft_economic_e",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      setIsLoading(false);
      console.log("DraftExpenseProvision_A response", response.data.data);
      if (response.data.status === true) {
        toast.success(response.data.message);
        setValidated(false); // Reset validation state
        setTimeout(() => {
          handleDataRefresh();
        }, 2000);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error.response.data.error);
    }
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Helmet>
            <title>मागासवर्गीय खर्चाची तरतूद</title>
          </Helmet>
          <div className="container common-section pt-0">
            <div className="row">
              <div className="col-lg-12 navigate-section-header mt-3">
                <div className="page-title">
                  <p className="fw-bold mb-2">१.१ आर्थिक वर्ष मागणी</p>
                </div>
                <div className="navigate-section d-flex">
                  <div className="arrow-box">
                    <Link to="/eco-a" className="text-dark">
                      अ) ग्रामपंचायत करमागणी ( घरपट्टी )
                    </Link>
                  </div>
                  <div className="arrow-box">
                    <Link to="/eco-b" className="ms-5 text-dark">
                      ब) पाणीपट्टी
                    </Link>
                  </div>
                  <div className="arrow-box">
                    <Link to="/eco-c" className="ms-5 text-dark">
                      क) किरकोळ मागणी
                    </Link>
                  </div>
                  <div className="arrow-box">
                    <Link to="/eco-d" className="ms-5 me-5 text-dark">
                      ड) पवनचक्की / कारखाना मागणी
                    </Link>
                  </div>
                  <div className="arrow-box-active d-flex flex-column justify-content-center me-3">
                    <Link to="/eco-c" className="text-decoration-none">
                      इ) खर्च तरतूद
                    </Link>
                    <span className="text-center arrow-icon">
                      <ArrowDropDownIcon fontSize="large" color="primary" />
                    </span>
                  </div>
                </div>
                {/* <TabEco/> */}
              </div>
              <div className="col-lg-12 mt-4 mb-4">
                <Village_Tal_Dist
                  villageDataInfo={villageDataInfo}
                  yearInfo={yearInfo}
                />
              </div>
              <div className="col-lg-12 " id="pdf-content">
                <div className="table-main-sec">
                  <div className="table_title_top">
                    <p>अ) १५% मागासवर्गीय खर्चाची तरतूद </p>

                    {economicData === "Y" ? (
                      <span className="drafted_text">
                        <FaEdit /> Drafted
                      </span>
                    ) : economicData === "N" ? (
                      <span className="submit_text">
                        Submitted{" "}
                        <img
                          src={require("../../component/assets/images/sumbit-success.png")}
                          alt="success"
                          width={30}
                          className="img-fluid"
                        />
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered" id="pdf-table">
                      <thead>
                        <tr>
                          <th scope="col" style={{ width: "5rem" }}>
                            अ.क्र.
                          </th>
                          <th scope="col">मागील अनुशेष</th>
                          <th scope="col">
                            चालू तरतूद <br /> (सन २०२२-२०२३)
                          </th>
                          <th scope="col">
                            एकूण तरतूद <br />
                            (मागील + चालू) (सन २०२२-२०२३)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr id="tableTd">
                          <td>
                            <input
                              type="number"
                              value={1}
                              disabled
                              className="form-control table-input-box"
                              style={{ background: "transparent" }}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              value={backLog}
                              onChange={(e) => setBackLog(e.target.value)}
                              onKeyDown={(evt) =>
                                ["e", "E", "+", "-", "*"].includes(evt.key) &&
                                evt.preventDefault()
                              }
                              placeholder={
                                validated && !isNumeric(backLog)
                                  ? "कृपया वैध क्रमांक प्रविष्ट करा."
                                  : ""
                              }
                              className={`form-control table-input-box ${
                                validated && !isNumeric(backLog)
                                  ? "is-invalid"
                                  : ""
                              }`}
                              ref={backLogRef}
                              autoFocus
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              value={currentProvision}
                              onChange={(e) =>
                                setCurrentProvision(e.target.value)
                              }
                              onKeyDown={(evt) =>
                                ["e", "E", "+", "-", "*"].includes(evt.key) &&
                                evt.preventDefault()
                              }
                              placeholder={
                                validated && !isNumeric(currentProvision)
                                  ? "कृपया वैध क्रमांक प्रविष्ट करा."
                                  : ""
                              }
                              className={`form-control table-input-box ${
                                validated && !isNumeric(currentProvision)
                                  ? "is-invalid"
                                  : ""
                              }`}
                              ref={currentProvisionRef}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              value={totalProvision}
                              readOnly
                              className="form-control fw-bold table-input-box"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 mt-5"
                      id="footerDevOfficer"
                      // style={{ display: "none" }}
                    >
                      <FooterDevOfficer villageDataInfo={villageDataInfo} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 d-flex mt-4 justify-content-end align-items=center">
                {(economicData === "" || economicData === "Y") && (
                  <FormBtn
                    resetForm={handleDataReset}
                    handleSubmit={handleFormSubmission}
                    handleDraft={handleDraftExpenseProvision}
                  />
                )}
              </div>
              {economicData === "N" && (
              <div className="col-lg-12 mb-5">
                <div className="d-flex justify-content-between">
                  <p className="text-danger">
                    सूचना : कृपया काही बदल करायचा असेल तर बी. डी. ओ. ला विनंती
                    करा.{" "}
                  </p>
                  <div>
                    <Button variant="contained">विनंती करा</Button>
                  </div>
                </div>
              </div>
            )}
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {" "}
                    सूचना <MdOutlineArrowDownward />
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Submit केल्यानंतर तुम्ही बी.डी.ओ. च्या मंजुरीशिवाय फॉर्म Edit
                  करू शकत नाही. कृपया खात्री करा की तुम्ही फॉर्म Submit करू
                  इच्छिता?
                </Modal.Body>
                <Modal.Footer className="gap-3">
                  <Button className="modal-button-cancel" onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button
                    className="modal-button-submit"
                    onClick={handleExpenseProvisionDetails}
                  >
                    Submit
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
            <EconomicsYear_Expanse1 />
            <EconomicsYear_Expanse2 />
          </div>
          <ToastContainer
            position={"top-center"}
            autoClose={2000}
            pauseOnHover={false}
            closeOnClick={true}
          />
        </>
      )}
    </>
  );
};

export default EconomicsYear_E;
